import Plain from "./Plain";

export function Contact() {
  return (
    <div>
      <br />
      <div>
        <h2 style={{ color: "white" }}>
          Contact Me on Gmail <hr />
        </h2>
        <br />
      </div>
      <a href="mailto:harnooraulakh16@gmail.com, secondemail@example.com">
        <div
          className="mail2"
        >
          <div style={{ display: "flex", flexDirection: "row", gap: "1rem" }}>
            <svg
              width="40"
              height="60"
              viewBox="0 6 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="rgb(228, 174, 72)"
                d="M4.615 19q-.69 0-1.152-.462Q3 18.075 3 17.385V6.615q0-.69.463-1.152Q3.925 5 4.615 5h14.77q.69 0 1.152.463q.463.462.463 1.152v10.77q0 .69-.462 1.152q-.463.463-1.153.463zM12 12.115l8-5.23L19.692 6L12 11L4.308 6L4 6.885z"
              />
            </svg>
            <h2 style={{ color: "rgb(228, 174, 72)" }}>Mail</h2>
          </div>
          <div>
            <h3 style={{ margin: "0" }}>MAIL ID</h3>
            <p style={{ margin: "0", color: "white" }}>
              harnooraulakh16@gamil.com
            </p>
          </div>
        </div>
      </a>
      <br />
      <div>
        <h2 style={{ color: "white" }}>
          Also View <hr />
        </h2>
        <br />
      </div>
      <div className="cards">
        <Plain link="https://www.linkedin.com/in/harnoor-singh-aulakh-046140226/" img="/linked.png">
          <p>Linkedin.Harnoor Singh Aulakh</p>
        </Plain>
        <Plain link="https://leetcode.com/harnooraulakh16/" img="/leetcode.png">
          <p>Leetcode.harnooraulakh16</p>
        </Plain>
      </div>
    </div>
  );
}
